import axios from 'axios';
import { handleResponse } from './HelperService';

const getPayment = (params, onSuccess, onError) => {
    const response = axios.get('v1/operationalcost', { params });
    return handleResponse(response, onSuccess, onError);
};
const createPayment = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/operationalcost`, payload);
    return handleResponse(response, onSuccess, onError);
};
const getPaymentById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/operationalcost/${id}`);
    return handleResponse(response, onSuccess, onError);
};
const cancelPayment = (id, onSuccess, onError) => {
    const response = axios.put('v1/operationalcost/'+ id + '/cancel');
    return handleResponse(response, onSuccess, onError);
}

export {
    getPayment,
    createPayment,
    getPaymentById,
    cancelPayment
};
